import * as React from "react";

const CheckboxIcon: React.FC<React.HTMLProps<SVGSVGElement>> = (props) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M11.333 5.708 6.75 10.291 4.667 8.208" stroke="#fff" strokeWidth="1.667" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export { CheckboxIcon }